import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

function useOnboardingTooltip(ref, index) {
  const [tooltipDisabled, setTooltipDisabled] = useState(true);
  const [hasShown, setHasShown] = useState(false);
  const onboardingIndex = useSelector((state) => state.onboarding.index);
  const onboardingActive = useSelector((state) => state.onboarding.active);

  useEffect(() => {
    // Only show tooltip if onboarding is active AND this is the current step
    if (onboardingActive && onboardingIndex === index) {
      // Show the tooltip after a short delay
      const showTimer = setTimeout(() => {
        if (!hasShown) {
          setTooltipDisabled(false);
          setHasShown(true);
        }
      }, 1000);

      // Hide the tooltip after it's been shown for a while
      const hideTimer = setTimeout(() => {
        setTooltipDisabled(true);
      }, 8500); // 1000ms delay + 7500ms showing

      return () => {
        clearTimeout(showTimer);
        clearTimeout(hideTimer);
      };
    } else {
      // Hide tooltip if onboarding is not active or this isn't the current step
      setTooltipDisabled(true);
    }
  }, [onboardingIndex, onboardingActive, hasShown, index]);

  return tooltipDisabled;
}

export default useOnboardingTooltip;
